function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0l33 33M0 33L33 0"
});

function SvgNavbarClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzMgMzMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGc+CiAgICA8bGluZSB4MT0iMCIgeTE9IjAiIHgyPSIzMyIgeTI9IjMzIiAvPgogICAgPGxpbmUgeDE9IjAiIHkxPSIzMyIgeDI9IjMzIiB5Mj0iMCIgLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgNavbarClose as ReactComponent };